import { PORTAL_ACTION } from "../actions";

const INITIAL_STATE = {
  welcomeMessage: "",
  siteConsultTypes: [],
  specialtyHintText: "I would like to make an appointment for",
  appointmentTypeHintText: "and this will be",
  practitionerHintText: "with",
  locationHintText: "at",
  timezoneHintText: "during the call I will be in the same time zone as",
  appointmentDateTimeHintText: "on",
  practitionerFirst: true
};

export const configReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PORTAL_ACTION.CONFIG_LOAD_SUCCESS:
      return { ...state, ...action.payload.config };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/reducers/configReducer.js